import React from 'react';
import PropTypes from 'prop-types';
import apiClient from 'clients/apiClient';
import compose from 'recompose/compose';
import config from 'helpers/config';
import fetchResourceById from 'components/hoc/fetchResourceById';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import UsersShow from './UsersShow';
import { fetchUser } from 'store/actions/users/fetchUsers';
import { showNotification } from 'store/actions/uiActions';
import { connect } from 'react-redux';

class UsersShowContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingWallets: false,
            wallets: [],
        };
    }

    componentDidMount() {
        this.refreshWallets();
    }

    toggleLoadingWallets = () => {
        this.setState((state) => {
            return {
                loadingWallets: !state.loadingWallets,
            };
        });
    }

    refreshWallets = () => {
        const { dispatchNotification, id } = this.props;

        this.toggleLoadingWallets();

        return apiClient.read(`${ config.getApiBaseUrl() }/users/${ id }/wallets`).then((response) => {
            this.setState({
                wallets: response,
            }, () => {
                this.toggleLoadingWallets();
            });
        }, (error) => {
            this.toggleLoadingWallets();

            dispatchNotification(error.response.message, 'warning');
        });
    }

    render() {
        const {
            data,
            history,
            id,
            resource,
            resourceFetchFailed,
            resourceFetchLoading,
        } = this.props;

        const { loadingWallets, wallets } = this.state;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        if (!data) {
            return null;
        }

        return <UsersShow
            history={ history }
            id={ id }
            loadingWallets={ loadingWallets }
            record={ data }
            refreshMemberships={ () => {
                return this.handleFetchMemberships();
            } }
            refreshWallets={ () => {
                return this.refreshWallets();
            } }
            resource={ resource }
            wallets={ wallets }
        />;
    }
}

UsersShowContainer.propTypes = {
    data: PropTypes.object,
    dispatchNotification: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const fetchValues = {
    resource: 'users',
    action: fetchUser,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchNotification: (text, type) => {
            dispatch(showNotification(text, type));
        },
    };
};

const enhance = compose(
    connect(null, mapDispatchToProps),
    fetchResourceById(fetchValues)
);

export default enhance(UsersShowContainer);



// WEBPACK FOOTER //
// ./src/pages/users/show/UsersShowContainer.js